import { useMemo } from 'react';
import { getLastCardNumberDigits } from '../utils';

export const useCardLastDigits = (cardNumber: string): string =>
  useMemo(() => getLastCardNumberDigits(cardNumber), [cardNumber]);
